export default {
	"coupon.SimilarCouponsAreMutuallyExclusive": "Similar coupons are mutually exclusive",
	"coupon.ThereAreNoCoupons": "There are no coupons",
	"coupon.WaiverOfOffer": "Waiver of offer",
	"coupon.ReasonsForUnavailability": "Reasons for unavailability:",
	"coupon.Selected": "Selected",
	"coupon.sheet": "sheet",
	"coupon.¥reductionIsAvailable": "¥reduction is available",
	"coupon.AreYouSure": "Are you sure"
}